import { gridDataSource, columnData } from './scorecard-finance-data';

export default function($el) {
    gridDataSource.bind('requestEnd', createGrid);
    gridDataSource.read();

    function resetGrid() {
        const { id } = $el[0];
        const top = $el.parents('.grid--scorecard');
        const newDiv = document.createElement('div');
        newDiv.id = id;
        $el.empty();
        top.empty();
        $el = $(newDiv);
        top.append(newDiv);
    }

    function removeGridTemplates() {
        $('.scorecard__popup-content.k-reset').remove();
    }

    $('#financeScorecardFilter').on('click', () => {
        $el.data('kendoGrid').destroy();
        resetGrid();
        removeGridTemplates();
        gridDataSource.read();
    });

    function noDataMessage(arg) {
        const msg = document.createElement('div');
        msg.id = 'noDataMsg';
        $(msg).text('No project(s) match the selected criteria.');
        $el.append(msg);
        $('#scorecardLoading').toggle(false);
    }

    function createGrid(e) {
        if (e.response === undefined || e.response.length === 0) return noDataMessage(e);
        try {
            const grid = $el.kendoGrid({
                autoBind: false,
                dataSource: gridDataSource,
                mobile: 'phone',
                resizable: false,
                height: 239, // Nudging to the table content
                columns: columnData.slice().reverse(),
                dataBound: onDataBound
            });
            const tabName = $('a.menu-topbar__link.--active')[0].text;
            $(document).trigger('on:RenderSparklines', [{ tabName }]);
            return grid;
        } catch {
            return noDataMessage(e);
        }
    }

    function scorecardPopup() {
        const $popupToggle = $('.scorecard__popup-toggle');
        if ($popupToggle.length) {
            $popupToggle.each(function(i) {
                const toggle = $(this);
                const popup = toggle.next();
                const anchor = toggle;

                popup.kendoPopup({
                    anchor,
                    origin: 'top right',
                    collision: 'fit',
                    animation: {
                        open: {
                            effects: 'fade:in'
                        }
                    }
                });

                toggle.click(() => popup.data('kendoPopup').toggle());
            });
        }
    }

    function assignStatus() {
        const $cells = $('.grid-cell--status');
        if ($cells.length) {
            $cells.each(function(i) {
                const cell = this;
                const statusNum = cell.getAttribute('data-status');
                let statusClass = '--blank';
                if (statusNum == 1) statusClass = '--pass';
                if (statusNum == 2) statusClass = '--warning';
                if (statusNum == 3) statusClass = '--fail';
                cell.classList.add(statusClass);
            });
        }
    }

    function onDataBound(arg) {
        scorecardPopup();
        assignStatus();
    }
}
